import { styled } from '@mui/material';

import { PageLayout } from '~/components/PageLayout/PageLayout.tsx';

export const PageLayoutStyled = styled(PageLayout)(({ theme }) => ({
  backgroundColor: theme.palette.grey['50'],
}));
